<template>
  <div class="vuestic-modal">
    <transition name="modal" :duration="duration">
      <div v-show="show" class="modal-container">
        <div class="modal" @click.self="clickMask">
          <div class="modal-dialog modal-sm">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">
                  Podtip uzorka: <strong>{{ sid }}</strong>
                </div>
              </div>
              <div class="modal-body">
                <div v-if="uzorciList.length === 0" style="text-align:center; padding:10px;">
                  <span>Učitavanje...</span>
                </div>
                <div v-else class="form-group" style="padding: 10px 0;">
                  <input
                    v-model="search"
                    class="form-control"
                    placeholder="Pretraga..."
                    style="margin-bottom: 6px; height: 34px;"
                    @keydown.stop
                  />
                  <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ddd; border-radius: 2px;">
                    <div
                      v-for="u in filteredUzorci"
                      :key="u._id"
                      @click="selectedTip = u.tip"
                      :style="{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        background: selectedTip === u.tip ? '#4ae387' : 'white',
                        color: selectedTip === u.tip ? 'white' : '#333',
                        borderBottom: '1px solid #eee'
                      }"
                    >{{ u.tip }}</div>
                    <div v-if="!filteredUzorci.length" style="padding: 8px 12px; color: #aaa;">Nema rezultata</div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-warning btn-sm" @click="cancel">ODUSTANI</button>
                <button type="button" class="btn btn-primary btn-sm" @click="ok" :disabled="!selectedTip">POTVRDI</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { http } from "../../../../config/config.js";
import { bus } from "../../../main";

export default {
  name: "vuestic-modal-select-podtip",
  data() {
    return {
      show: false,
      duration: 500,
      uzorciList: [],
      selectedTip: "",
      search: "",
      sid: "",
      currentTip: ""
    };
  },
  computed: {
    filteredUzorci() {
      var s = this.search.toLowerCase();
      return s ? this.uzorciList.filter(u => u.tip.toLowerCase().includes(s)) : this.uzorciList;
    }
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },
  watch: {
    show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    open(sample) {
      this.sid = sample.sid;
      this.currentTip = sample.tip || "";
      this.selectedTip = "";
      this.search = "";
      this.uzorciList = [];
      http
        .get(
          "postavke/list/def/uzorak?token=" +
            this.$store.state.token +
            "&site=" +
            this.$store.state.site
        )
        .then(res => {
          if (res.data.success && res.data.uzorci) {
            this.uzorciList = res.data.uzorci;
          }
          this.show = true;
        });
      window.addEventListener("keyup", this.listenKeyUp);
    },
    cancel() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask() {},
    ok() {
      if (!this.selectedTip) return;
      http
        .post(
          "uzorci/set/tip/" +
            this.sid +
            "?token=" +
            this.$store.state.token +
            "&site=" +
            this.$store.state.site,
          { tip: this.selectedTip }
        )
        .then(res => {
          if (res.data.success) {
            bus.$emit("PodtipUpdated", {
              sid: this.sid,
              tip: res.data.tip
            });
          }
          this.show = false;
          window.removeEventListener("keyup", this.listenKeyUp);
        });
    }
  }
};
</script>

<style lang="scss">
@import "../../../sass/_variables.scss";

$modal-header-padding-x: $widget-padding;
$modal-header-padding-y: 0;
$modal-header-height: $widget-header-height;
$modal-header-border: $widget-header-border;
$modal-content-border-width: 0;
$modal-content-border-radius: 0;
$modal-inner-padding: 25px;
$modal-footer-btns-padding-bottom: 20px;
$modal-footer-btns-margin-x: 10px;

.vuestic-modal {
  height: 0;
  width: 0;

  .modal {
    display: block;
  }

  .modal-dialog,
  .modal-backdrop {
    transition: all 0.5s ease;
  }

  .modal-enter .modal-dialog,
  .modal-leave-active .modal-dialog {
    opacity: 0;
    transform: translateY(-30%);
  }

  .modal-enter .modal-backdrop,
  .modal-leave-active .modal-backdrop {
    opacity: 0;
  }

  .modal-backdrop {
    opacity: 0.5;
  }

  .modal-header {
    height: $modal-header-height;
    padding: $modal-header-padding-y $modal-header-padding-x;
    border-bottom: $modal-header-border;
    font-size: $font-size-larger;
    display: flex;
    align-items: center;
  }

  .modal-content {
    border-radius: $modal-content-border-radius;
  }

  .modal-footer {
    justify-content: center;
    padding: 0 $modal-inner-padding;
    padding-bottom: calc(#{$modal-inner-padding} - #{$modal-footer-btns-padding-bottom});
    flex-wrap: wrap;
    .btn {
      margin: 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom $modal-footer-btns-margin-x;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/obrada/components/VuesticModalSelectPodtip.vue